import React, { Component } from 'react'
// import CaseContent from './CaseContent'
import Content from './Content'

export default class extends Component {
  render() {
    return <Content {...this.props} />
  }
}
